import { createFileRoute, redirect } from "@tanstack/react-router";

import { isSkuStoreStoriesEnabled } from "@/features/SKUStore/flag";
import { SKUStoreStoriesPage } from "@/features/SKUStore/SKUStoreStoriesPage";

export const Route = createFileRoute(
  "/_auth/sku-store/$siteId/$skuId/stories/",
)({
  beforeLoad: ({ params }) => {
    if (!isSkuStoreStoriesEnabled()) {
      throw redirect({
        to: "/sku-store/$siteId/$skuId",
        params: { siteId: params.siteId, skuId: params.skuId },
      });
    }
  },
  component: SKUStoreStoriesPage,
});
